import jQuery from 'jquery'
import Chocolat from 'chocolat'

jQuery.fn.Chocolat = Chocolat
